import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import TopicBasicInfoComponent from './topic-basic-info.component';

export const TopicComponent = ({
  parentTopicsList, handleInnerFormChange, selectedTopics, back, handleFormSubmit
}: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Topic Basic Information',
      component: <TopicBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedTopics={selectedTopics}
        parentTopicsList={parentTopicsList}
      />,
      isVisible: true,
    },
  ]

  return (
    <>
      <TabContainer tabItems={tabItems} />
      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </>
  )
}

export default TopicComponent;
